import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import validate from './validation'
import * as ContentActions from '../../../../actions/content'
import { notify as notifyAction } from '../../../../actions/notifications'
import { PlaylistsForm } from '../../../../components/Screens'
import { ContentTypes } from '../../../../constants'
import { playlistsForm as playlistsFormProps } from '../../../../types'
import { ObjectUtils } from '../../../../utils'

// Default start date
const defaultStartDateDate = new Date()
defaultStartDateDate.setHours(0)
defaultStartDateDate.setMinutes(0)
defaultStartDateDate.setSeconds(0)
const defaultStartDate = defaultStartDateDate.getTime()

// Default end date
const defaultEndDateDate = new Date()
defaultEndDateDate.setDate(new Date().getDate() + 366)
defaultEndDateDate.setHours(0)
defaultEndDateDate.setMinutes(0)
defaultEndDateDate.setSeconds(0)
const defaultEndDate = defaultEndDateDate.getTime()

class Layers extends PureComponent {
    static propTypes = {
        editFormValue: PropTypes.func.isRequired,
        form: PropTypes.shape(playlistsFormProps).isRequired,
        isOpen: PropTypes.bool,
        isWorking: PropTypes.bool.isRequired,
        onClickCancel: PropTypes.func,
        onFinishSubmit: PropTypes.func,
        createPlaylist: PropTypes.func.isRequired,
        resetUpload: PropTypes.func.isRequired,
        resetForm: PropTypes.func.isRequired,
        selectedChainId: PropTypes.number,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        isOpen: false,
        onClickCancel: () => null,
        onFinishSubmit: () => null,
    }

    constructor(props) {
        super(props)

        this.state = {
            formErrors: {
                name: null,
                date_start: null,
                date_end: null,
                slug: null,
            },
        }

        this.onChangeFormValue = this.onChangeFormValue.bind(this)
        this.onClickNullStartDate = this.onClickNullStartDate.bind(this)
        this.onClickNullEndDate = this.onClickNullEndDate.bind(this)
        this.onClickRemoveStartDate = this.onClickRemoveStartDate.bind(this)
        this.onClickRemoveEndDate = this.onClickRemoveEndDate.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidUpdate(lastProps) {
        const { selectedChainId } = this.props
        const { selectedChainId: prevChainId } = lastProps

        if (prevChainId !== selectedChainId) {
            this.onChangeChainId(selectedChainId)       
        } 
    }

    onChangeFormValue({ target: { name, value } }) {
        const { editFormValue } = this.props
        editFormValue('playlists', { name, value })
    }

    onChangeChainId = (chainValue) => {
        const { editFormValue } = this.props;
        editFormValue(ContentTypes.PLAYLISTS, { name: 'chain_id', value: chainValue });
    }

    onClickNullStartDate() {
        this.onChangeFormValue({
            target: { name: 'date_start', value: defaultStartDate },
        })
    }

    onClickNullEndDate() {
        this.onChangeFormValue({
            target: { name: 'date_end', value: defaultEndDate },
        })
    }

    onClickRemoveStartDate() {
        this.onChangeFormValue({
            target: { name: 'date_start', value: null },
        })
    }

    onClickRemoveEndDate() {
        this.onChangeFormValue({
            target: { name: 'date_end', value: null },
        })
    }

    async onSubmit() {
        if (!this.validate()) {
            return
        }

        const { form, onFinishSubmit, createPlaylist, resetUpload } = this.props
        const action = await createPlaylist(form)
        await onFinishSubmit(action)
        await resetUpload(ContentTypes.PLAYLISTS)
    }

    buildOnchangeObject() {
        return {
            name: this.onChangeFormValue,
            date_start: (value) => this.onChangeFormValue({ target: { name: 'date_start', value } }),
            date_end: (value) => this.onChangeFormValue({ target: { name: 'date_end', value } }),
            slug: this.onChangeFormValue,
            chain_id: this.onChangeChainId,
        }
    }

    /**
     * Form Validation
     */
    validate() {
        const { form } = this.props
        const formErrors = validate(form)
        this.setState({ formErrors })
        return ObjectUtils.isObjValuesEmpty(formErrors)
    }

    onClickCancel = () => {
        const { onClickCancel, resetForm } = this.props
        onClickCancel()
        resetForm('playlists')
    }

    render() {
        const { form, isOpen, isWorking, t } = this.props
        const { formErrors } = this.state
        return (
            <PlaylistsForm
                errors={formErrors}
                isOpen={isOpen}
                isWorking={isWorking}
                onChangeForm={this.buildOnchangeObject()}
                onClickCancel={this.onClickCancel}
                onClickSubmit={this.onSubmit}
                onClickNullStartDate={this.onClickNullStartDate}
                onClickNullEndDate={this.onClickNullEndDate}
                onClickRemoveStartDate={this.onClickRemoveStartDate}
                onClickRemoveEndDate={this.onClickRemoveEndDate}
                values={form}
                t={t}
            />
        )
    }
}

const mapStateToProps = ({
    content: {
        isWorking: { playlists: isWorking },
        layers: data,
        form: { playlists: form },
    },
}) => ({
    data,
    form,
    isWorking,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
            notify: notifyAction,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Layers))
